import React from 'react';
import welcomeImage from '../assets/welcome-woman.png';
import doorImage from '../assets/door-image.png'; 
import ratingImage from '../assets/rating-app-illustration.png'; 
import IconUI from "../assets/Iicon-user-interface.png";
import IconFeedback from "../assets/icon-anonymous-feedback.png";
import IconCriteria from "../assets/icon-modifiable-criteria.png";
import IconPerformance from "../assets/icon-performance.png";
import IconShift from "../assets/icon-paradigm-shift.png";
import IconData from "../assets/icon-transparent-data.png";
import IconGrowth from "../assets/icon-growth.png";
import IconEmpowerment from "../assets/icon-empowerment.png";
import IconTeam from "../assets/icon-thriving-team.png";
import cornerPattern from "../assets/cornerPattern.jpg";
import checkIcon from "../assets/bcheckIcon.svg";
import { motion } from "framer-motion";
import { useState, useEffect,useRef } from "react";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Helmet } from "react-helmet";

import { toast, ToastContainer } from "react-toastify";
 
import { useNavigate } from 'react-router-dom'; 





const benefits = [
  "In-depth reviews can be left by users to help others learn from their experiences.",
  "The app rates goods and services in a flash using a star system.",
  "For the most recent information, ratings and reviews are updated in real time.",
  "In-depth reviews can be left by users to help others learn from their experiences.",
  "The app rates goods and services in a flash using a star system.",
  "For the most recent information, ratings and reviews are updated in real time.",
];




const features = [
  {
    icon: IconShift,
    title: "Paradigm shift",
    description:
      "Feedback now delivers real-time, data-driven insights that drive continuous improvement and boost agility.",
    bg: "bg-[#DFFCF2]",
  },
  {
    icon: IconData,
    title: "Transparent & Data-driven",
    description:
      "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
    bg: "bg-[#F3F2FF]",
  },
  {
    icon: IconGrowth,
    title: "Driving constant growth",
    description:
      "Continuous improvement fuels growth by refining processes and products through customer feedback.",
    bg: "bg-[#E7FEE1]",
  },
  {
    icon: IconEmpowerment,
    title: "Empowerment of workforce",
    description:
      "Employee empowerment provides workers with the resources and support to make decisions that benefit both the organization and themselves.",
    bg: "bg-[#FFF8DC]",
  },
  {
    icon: IconTeam,
    title: "Building a thriving team",
    description:
      "A collaborative, dynamic workplace respects diverse views and fosters cooperation and creativity, driving both success and employee happiness.",
    bg: "bg-[#F8F8F8]",
  },
  ];
const featuress = [


  {
    title: "User-Friendly Interface",
    description:
      "The app’s intuitive interface ensures easy use and broad participation, allowing employees to quickly rate peers based on their observations.",
    icon: IconUI,
    bg: "bg-[#D7F3FB]",
  },
  {
    title: "Anonymous Feedback",
    description:
      "The Rating App ensures anonymity, encouraging honest feedback and fostering a culture of transparency and trust without fear of consequences.",
    icon: IconFeedback,
    bg: "bg-[#EDE4FF]",
  },
  {
    title: "Modifiable evaluation criteria",
    description:
      "Businesses can customize evaluation criteria to align with their goals, as the Rating Application adapts to prioritize what matters most.",
    icon: IconCriteria,
    bg: "bg-[#FEF3C7]",
  },
  {
    title: "From potential to performance",
    description:
      "Top performers are recognized for their achievements, while all employees use peer feedback to identify growth areas.",
    icon: IconPerformance,
    bg: "bg-[#FEE2E2]",
  },
];

const HospitalitySection = () => {

   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };
    const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
    const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <>
 <Helmet>
        <title>Next-Level Hospitality Solutions | Employee Feedback & Rating App</title>
        <meta name="description" content="Enhance hospitality operations with LENTERA’s innovative Rating App. Capture anonymous employee feedback, improve teamwork, boost performance, and drive continuous growth with real-time, data-driven insights."/>
        <meta name="keywords" content="LENTERA hospitality solutions, continuous improvement in hospitality, team performance optimization."/>
      </Helmet>

    <section className="w-full bg-[#e8d9ff] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="uppercase text-sm font-medium text-black mb-2">
        Hospitality
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
            Welcome to Next-Level<br />hospitality 
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
         Step into a world where comfort meets sophistication, and every detail is crafted with you in mind.
            Our approach to hospitality goes beyond expectations.
      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      
    
            <img src={welcomeImage} alt="Welcome" className="w-[400px] h-auto" />

    </motion.div>

  </div>
</section>
    
      
    <section className="bg-[#121212] py-20">
  <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-12">
    
    {/* Left Image */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
      className="md:w-1/2 flex justify-center md:justify-start"
    >
      <div className="bg-white rounded-2xl p-4">
        <img
          src={doorImage}
          alt="Overview"
          className="rounded-xl w-[400px] h-auto"
        />
      </div>
    </motion.div>

    {/* Right Text Content */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, delay: 0.2 }}
      viewport={{ once: true }}
      className="md:w-1/2 text-white"
    >
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
        className="text-2xl font-semibold mb-4"
      >
        Overview
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        viewport={{ once: true }}
        className="text-lg mb-6 text-gray-300"
      >
        Employee input plays a critical role in creating a productive and healthy work
        environment in today‘s fast-paced corporate world.
      </motion.p>

      <motion.hr
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        transition={{ duration: 0.5, delay: 0.6 }}
        viewport={{ once: true }}
        className="border-gray-50 mb-6 w-32 origin-left"
      />

      <motion.h3
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        viewport={{ once: true }}
        className="text-2xl font-semibold mb-4"
      >
        Our impact on hospitality industries
      </motion.h3>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        viewport={{ once: true }}
        className="text-lg text-gray-300"
      >
        Traditional feedback methods often miss the mark.{" "}
        <span className="font-semibold text-white">LENTERA’s Rating App</span> transforms
        how businesses capture and use employee input.
      </motion.p>
    </motion.div>
  </div>
</section>

     <section className="bg-white py-20">
  <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-12">
    
    {/* Left Text Content */}
    <motion.div
      initial={{ opacity: 0, x: -40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7 }}
      viewport={{ once: true }}
      className="md:w-1/2"
    >
      <span className="inline-block bg-green-100 text-green-600 font-semibold text-sm px-4 py-1 rounded-full mb-4">
        OUR RATING APP
      </span>
      <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
        Where feedback meets innovation
      </h2>
      <p className="text-lg text-gray-700">
        Lentera’s Rating App lets staff anonymously rate colleagues across predefined categories 
        like problem-solving, leadership, and communication. This structured feedback helps businesses 
        identify strengths and pinpoint areas for improvement with clarity.
      </p>
    </motion.div>

    {/* Right Image */}
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.3 }}
      viewport={{ once: true }}
      className="md:w-1/2 flex justify-center"
    >
      <div className="rounded-full bg-yellow-50 p-4">
        <img
          src={ratingImage}
          alt="Rating App Illustration"
          className="w-[400px] h-auto rounded-full"
        />
      </div>
    </motion.div>
  </div>
</section>

   

<section className="w-full bg-[#141416] px-6 py-20 font-[Poppins] text-white">
  <div className="max-w-[1240px] mx-auto">
    {/* Header */}
    <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-6 mb-12">
      <h2 className="text-[40px] sm:text-[48px] font-bold leading-tight max-w-[500px]">
        Your benefits <br className="hidden md:block" /> with us
      </h2>
      <p className="text-[16px] leading-[28px] text-[#E1E1E1] max-w-[520px]">
        Experience hands-on learning, industry-relevant skills, and dedicated
        support that empower you to thrive in the real world.
      </p>
    </div>

    {/* Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {benefits.map((text, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="relative w-full bg-[#64EDAA] text-[#0F0F0F] rounded-[16px] p-6 min-h-[100px] flex items-center overflow-visible"
        >
          {/* Background Pattern (slightly more visible) */}
          <img
            src={cornerPattern}
            alt="pattern"
            className="absolute top-0 left-0 w-[72px] h-[72px] opacity-10 pointer-events-none"
          />

          {/* Yellow checkmark circle positioned properly */}
          <div className="absolute -top-4 -right-4 w-[40px] h-[40px] bg-[]  flex items-center justify-center z-20">
            <img
              src={checkIcon}
              alt="check"
              className="w-[35px] h-[35px] object-contain"
            />
          </div>

          {/* Text content */}
          <p className="text-[16px] font-medium leading-snug z-10 relative">
            {text}
          </p>
        </motion.div>
      ))}
    </div>
  </div>
</section>

    <section className="w-full bg-[#F8F8F8] py-[80px] font-[Poppins]">
  <div className="max-w-[1200px] mx-auto px-4 text-center">
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-[40px] font-semibold text-[#111827] leading-[48px] mb-[12px]"
    >
      Enhancing the quality of healthcare
    </motion.h2>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className="text-[18px] text-[#444444] leading-[30px] max-w-[720px] mx-auto mb-[60px]"
    >
      We empower healthcare providers with smart tools and services that enhance care quality and improve patient outcomes.
    </motion.p>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-[32px]">
      {featuress.map((feature, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: idx * 0.1 }}
          viewport={{ once: true }}
          className="bg-white rounded-[12px] shadow-md overflow-hidden text-left"
        >
          <div className={`${feature.bg} px-[24px] py-[20px] flex items-center gap-[16px]`}>
            <img src={feature.icon} alt={feature.title} className="w-[40px] h-[40px]" />
            <h3 className="text-[18px] font-semibold text-[#111827]">{feature.title}</h3>
          </div>
          <div className="px-[24px] pt-[16px] pb-[24px]">
            <p className="text-[16px] leading-[26px] text-[#444444]">{feature.description}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
</section>

<section className="w-full py-[80px] font-[Poppins] bg-white">
  <div className="max-w-[1200px] mx-auto px-4 text-center">
    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-[40px] font-bold text-[#111827] leading-[48px] mb-[12px]"
    >
      Key features
    </motion.h2>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
      className="text-[18px] text-[#444444] leading-[30px] mb-[60px]"
    >
      Discover the game-changing key features that set you apart!
    </motion.p>

    {/* Top 3 Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-[24px] mb-[24px]">
      {features.slice(0, 3).map((feature, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: idx * 0.1 }}
          viewport={{ once: true }}
          className={`${feature.bg} rounded-[24px] text-left px-[24px] py-[28px]`}
        >
          <img src={feature.icon} alt={feature.title} className="w-[48px] h-[48px] mb-[20px]" />
          <h3 className="text-[20px] font-semibold text-[#111827] leading-[28px] mb-[12px]">
            {feature.title}
          </h3>
          <p className="text-[16px] text-[#444444] leading-[26px]">{feature.description}</p>
        </motion.div>
      ))}
    </div>

    {/* Remaining Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-[24px]">
      {features.slice(3).map((feature, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: idx * 0.1 }}
          viewport={{ once: true }}
          className={`${feature.bg} rounded-[24px] text-left px-[24px] py-[28px]`}
        >
          <img src={feature.icon} alt={feature.title} className="w-[48px] h-[48px] mb-[20px]" />
          <h3 className="text-[20px] font-semibold text-[#111827] leading-[28px] mb-[12px]">
            {feature.title}
          </h3>
          <p className="text-[16px] text-[#444444] leading-[26px]">{feature.description}</p>
        </motion.div>
      ))}
    </div>
  </div>
</section>

     
     <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
  <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
        </>

  );
};

export default HospitalitySection;
